// import '../css/userProfile.css';
import { useNavigate } from "react-router-dom";
import TopHeader from "../../components/comman/TopHeader";
import Sidebar from "../../components/comman/Sidebar";
import { getSidebarMenus } from "../../constants/sidebarMenus";

import {
  faUser,
  faEnvelope,
  faWallet,
  faCog,
  faCircleCheck,
  faStar,
  faCreditCard,
  faVideo,
  faUsers,
  faBookmark,
} from "@fortawesome/free-solid-svg-icons";
import {
  saveToken,
  saveUserId,
  getCurrentUserId,
  getCurrentUserRole,
  logout,
  isLoggedIn,
  getToken,
} from "../../utils/auth";

import HeadProfile from "../../components/profile/HeadProfile";

import { useState, useEffect } from "react";
import "../../css/User/userProfile.css";
import { useProfile } from "../../hook/useProfile";

export default function UserProfile() {
  const currentUserId = getCurrentUserId();
  const { IsUserProfile } = useProfile();
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(true);
  const {
    isProfileInfo,
    updateProfile,
    isLoading,
    isState: contextStates,
  } = useProfile();

  /* ================= IMPORTANT FOR LAYOUT START ================= */
  const [feedType, setFeedType] = useState("prime");
  const [activeSidebar, setActiveSidebar] = useState("profile");
  /* ================= MESSAGE DRAWER START ================= */
  const [showMsgDrawer, setShowMsgDrawer] = useState(false);
  /* ================= MESSAGE DRAWER END ================= */
  const [districtOptions, setDistrictOptions] = useState([]);

  // FOR FORM DATA
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    age: "",
    bio: "",
    profession: "",
    gender: "",
    statePublic: "",
    districtPublic: "",
    statePrivate: "",
    districtPrivate: "",
    aadhar: "",
    pan: "",
    password: "",
    isProfileLocked: false,
    isBatch: false,
  });
  // EDIT POPUP
  const [editPopup, setEditPopup] = useState({
    isOpen: false,
    field: "",
    label: "",
    value: "",
  });

  // Sidebar Menu Error
  const sidebarMenus = getSidebarMenus(currentUserId);

  /* ================= POPUP SAVE (LOCAL ONLY) ================= */
  const handlePopupSave = () => {
    setFormData((prev) => ({
      ...prev,
      [editPopup.field]: editPopup.value,
    }));

    closePopup(); // no API call here
  };

  /* ================= CLOSE POPUP ================= */
  const closePopup = () => {
    setEditPopup({ isOpen: false, field: "", label: "", value: "" });
    setDistrictOptions([]);
  };

  /* ================= IMPORTANT FOR LAYOUT END ================= */

  const handleLogout = () => {
    const confirmLogout = window.confirm("Are you sure you want to logout?");

    if (confirmLogout) {
      // localStorage.clear();
      navigate("/login");
    }
  };

  const menuItems = [
    { id: "Prime", label: "Prime", icon: faStar, path: "/prime" },
    { id: "Public", label: "Public", icon: faUsers, path: "/public" },
    {
      id: "Revolution",
      label: "Revolution",
      icon: faVideo,
      path: "/revolution",
    },
    { id: "wallet", label: "Wallet", icon: faCreditCard, path: "/wallet" },
    {
      id: "Profile",
      label: "Verified",
      icon: faCircleCheck,
      path: "/verified",
    },
    { id: "settings", label: "Settings", icon: faCog, path: "/profile" },
  ];

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 967) {
        setShowSidebar(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.addEventListener("resize", handleResize);
  }, []);

  const handleLogoClick = () => {
    if (window.innerWidth <= 967) {
      setShowSidebar((prev) => !prev);
    }
  };

  return (
    <>
      <div className="container-xxl p-0">
        <div className="feed-page-wrapper">
          {/* <div className="page-container"> */}

          {/* ================= TOP HEADER NAVBAR ================= */}

          <TopHeader
            onToggleSidebar={() => setShowSidebar((prev) => !prev)}
            onOpenMessages={() => setShowMsgDrawer(true)}
            creditAmount={50}
            notificationCount={5}
            messageCount={0}
          />

          {/* ================= PRIME PUBLIC LAYOUT CONTAINER ================= */}
          <div className="prime-layout-container .container-fluid">
            <div className="row">
              {/* ================= LEFT SIDEBAR ================= */}
              {/* ===== LEFT SIDEBAR OVERLAY ===== */}
              {!showSidebar && (
                <div
                  className="left-sidebar-overlay d-md-none"
                  onClick={() => setShowSidebar(true)}
                />
              )}

              {/* SIDEBAR COMPONENT */}
              <Sidebar
                showSidebar={showSidebar}
                sidebarMenus={sidebarMenus}
                activeSidebar={activeSidebar}
                feedType={feedType}
                onNavigate={(item) => navigate(item.path)}
                onLogout={handleLogout}
              />
              {/* LEFT SIDEBAR END */}

              {/* ================= CENTER AREA ================= */}
              <div className="col-lg-9 col-md-9 col-12 overflow-auto center-area-container">
                <div className="center-area">
                  {/* ================= CENTER AREA START ================= */}
                  <div className="w-100 pb-5">
                    {/* USER PROFILE START */}
                    <div className="profile-page">
                      <HeadProfile MyProfile={IsUserProfile} />
                      {/* <div className="profile-content">
                                                {
                                                    IsUserProfile.isLocked ? (
                                                        <div className="private-message">
                                                            <h3>Profile is Private</h3>
                                                            <p>You cannot view posts or details for this account.</p>
                                                        </div>
                                                    ) : (
                                                        <h2>unlock your profile</h2>
                                                    )
                                                }
                                            </div> */}
                    </div>
                    {/* USER PROFILE END */}
                  </div>
                  {/* ================= CENTER AREA END ================= */}
                </div>
              </div>

              {/* ================= RIGHT SIDEBAR ================= */}
            </div>
          </div>

          {/*============== EDIT POPUP START =============*/}
          {editPopup.isOpen && (
            <div className="popup-overlay">
              <div className="popup-box">
                <h3>Edit {editPopup.label}</h3>

                {editPopup.field.includes("state") ? (
                  <select
                    value={editPopup.value}
                    onChange={(e) =>
                      setEditPopup((prev) => ({
                        ...prev,
                        value: e.target.value,
                      }))
                    }
                  >
                    <option value="">Select State</option>
                    {contextStates?.map((s, i) => (
                      <option key={i} value={s.stateName}>
                        {s.stateName}
                      </option>
                    ))}
                  </select>
                ) : editPopup.field.includes("district") ? (
                  <select
                    value={editPopup.value}
                    onChange={(e) =>
                      setEditPopup((prev) => ({
                        ...prev,
                        value: e.target.value,
                      }))
                    }
                  >
                    <option value="">Select District</option>
                    {districtOptions.map((d, i) => (
                      <option key={i} value={d}>
                        {d}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    type={editPopup.field === "password" ? "password" : "text"}
                    value={editPopup.value}
                    onChange={(e) =>
                      setEditPopup((prev) => ({
                        ...prev,
                        value: e.target.value,
                      }))
                    }
                  />
                )}

                <div className="popup-actions">
                  <button onClick={closePopup}>Cancel</button>
                  <button onClick={handlePopupSave}>Save</button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
